<template>
  <SoDialog
    v-model="value"
    card-title="Delete prize?"
    :max-width="440"
    data-testid="prize-delete-dialog"
  >
    <p>
      Are you sure you want to delete
      <strong>{{ reward?.name }}</strong
      >?
    </p>
    <div class="d-flex justify-end mt-4">
      <SoButton title="Cancel" class="mr-2" large @click="value = false" />
      <SoButton
        title="Delete"
        type="danger"
        large
        :loading="deleteMutation.isPending"
        data-testid="prize-delete-confirm-btn"
        @click="confirmDelete"
      />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { useSnackbarStore } from "@/stores/snackbar"
  import errorHandler from "@/services/ErrorService/errorHandler"
  import { IDrawReward } from "@/models/operations/draw/drawReward.types"
  import { LoyaltyMutator } from "@/mutators/loyalty/LoyaltyMutator"

  export default defineComponent({
    components: { SoDialog, SoButton },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      drawId: {
        type: String,
        required: true,
      },
      reward: {
        type: Object as PropType<IDrawReward | null>,
        default: null,
      },
    },
    emits: ["update:modelValue", "saved"],
    data() {
      return {
        snackbar: useSnackbarStore(),
        deleteMutation: LoyaltyMutator.deleteReward(),
      }
    },
    computed: {
      value: {
        get(): boolean {
          return this.modelValue
        },
        set(newValue: boolean) {
          this.$emit("update:modelValue", newValue)
        },
      },
    },
    methods: {
      async confirmDelete() {
        if (!this.reward) return
        try {
          await this.deleteMutation.mutateAsync({
            drawId: this.drawId,
            rewardId: this.reward.id,
          })
        } catch (error) {
          errorHandler.showCaughtError(error, "Failed to delete prize")
          return
        }
        this.snackbar.addSuccess("Prize deleted")
        this.$emit("saved")
        this.value = false
      },
    },
  })
</script>
